import * as React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import germanyBlog from '@icons/flags/germanyBlog';
import usaBlog from '@icons/flags/usaBlog';
import ResourceLink from '../ResourceLink';
import * as styles from './style.module.scss';

const { alternateVersion, alternateVersion__link } = styles;

const AlternateVersionTag = ({ resource }) => {
  const { t } = useTranslation();
  const { language } = useI18next();
  return (
    <p className={alternateVersion}>
      {language === 'de' ? usaBlog : germanyBlog} {t('blog_post_page_article')}{' '}
      <ResourceLink
        resource={resource}
        className={alternateVersion__link}
        alternateLanguage={language === 'de' ? 'en' : 'de'}
      >
        {t('blog_post_page_article_available')}
      </ResourceLink>
    </p>
  );
};

export default AlternateVersionTag;
